import {
    SimpleDialogImageProps,
    IconColor,
} from '@/libs/material/simple-dialog/types';
import SimpleDialog from '@rhg/libs/material/simple-dialog';
import { ComponentProps, ReactElement } from 'react';

type DialogPropsSubset = Pick<
    ComponentProps<typeof SimpleDialog>,
    | 'sx'
    | 'icon'
    | 'hideCloseButton'
    | 'title'
    | 'trackCloseButton'
    | 'onDismiss'
    | 'trackDialog'
    | 'trackScreen'
    | 'trackProps'
    | 'trackFeature'
    | 'content'
    | 'contentContainerStyle'
    | 'buttons'
    | 'disableMobileFullscreen'
    | 'boundContentHeight'
    | 'skipDialogViewedTracking'
    | 'aria-label'
    | 'aria-labelledby'
>;

export type SheetDialogVariant =
    | 'default'
    | 'gradient'
    | 'contrast'
    | 'contrastGradient';

export const SheetDialogVariant = {
    Default: 'default' as SheetDialogVariant,
    Contrast: 'contrast' as SheetDialogVariant,
    Gradient: 'gradient' as SheetDialogVariant,
    ContrastGradient: 'contrastGradient' as SheetDialogVariant,
};

export type SheetDialogProps = {
    onOpen?: () => void;
    onClose: () => void;
    stackBottomActions?: boolean;
    variant?: SheetDialogVariant;
    feature?: ReactElement;
    iconColor?: IconColor;
    /** Content spans the dialog's width inside the content gutter instead of the reading-width column. */
    fullWidthContent?: boolean;
} & DialogPropsSubset &
    SimpleDialogImageProps;
